import React from 'react';
import { PropTypes } from 'react';
import { ItemTypes } from '../commonJS/constants';
import getSort from '../commonJS/getSort';
import { DropTarget } from 'react-dnd';
import { DragSource } from 'react-dnd';

import MaskLink from './MaskLink';
import RemoveIcon from './RemoveIcon';

// spec, collet for drag source
const previewSource = {
  beginDrag(props) {
    return { fileName: props.fileName };
  },
  canDrag(props, monitor) {
    let productId;
    if (props.containerThis.props.params) productId = props.containerThis.props.params.productId;
    return props.containerThis.state.onEdit || !productId || props.containerThis.state.onCopy;
  }
}

function collectSource(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    // customerize the drag preview
    // connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  }
}

// spec, collet for drop target
const previewTarget = {
  // drop(props, monitor) {
  //   const srcFileName = monitor.getItem().fileName,
  //         srcInd = getSort(props.fileSort, srcFileName),
  //         tarInd = getSort(props.fileSort, props.fileName);


  //   props.fileSort.splice(srcInd, 1);
  //   props.fileSort.splice(tarInd, 0, srcFileName);
  //   // 即使state值相同仍會觸發render，這值得研究觸發機制提升效能
  //   props.parentStateHandler({states: 'forceUpdate', values: true});
  // }

  hover(props, monitor, component) {
    const srcFileName = monitor.getItem().fileName,
      srcInd = getSort(props.fileSort, srcFileName),
      tarInd = getSort(props.fileSort, props.fileName);

    // Don't replace items with themselves
    if (srcInd === tarInd) {
      return;
    }

    props.fileSort.splice(srcInd, 1);
    props.fileSort.splice(tarInd, 0, srcFileName);
    // 即使state值相同仍會觸發render，這值得研究觸發機制提升效能
    props.parentStateHandler({ states: ['forceUpdate', 'sholudUpdateFilesSort'], newValues: [true, true] });
  }
};

function collectTarget(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}

const PreviewImg = props => {
  let onDragging = false;
  // let onOver;

  if (props.enableDnd) {
    const { isDragging/*, isOver*/ } = props;
    onDragging = isDragging;
    // onOver = isOver;
  }

  const
    temp =
      <figure style={{ opacity: onDragging ? 0 : 1 }}>
        <img role='img' src={props.src || props.href} alt='thumbnail' onError={event => { event.target.src = '/imgs/no_image_default.png'; event.target.onerror = null; }} />

        <MaskLink href={props.href} />

        <RemoveIcon onFileDelete={e => {
          e.stopPropagation();
          props.ownerThis.onFileDelete(props.fileType, props.fileName);
        }} />
      </figure>;

  if (props.enableDnd) {
    const { connectDragSource, connectDropTarget } = props;
    return connectDragSource(connectDropTarget(temp));
  } else {
    return (temp);
  }
};

const PreviewPDF = props => {
  let onDragging = false, newSrc = '/icon/img_no_documented.png';
  // let onOver;

  if (props.enableDnd) {
    const { isDragging/*, isOver*/ } = props;
    onDragging = isDragging;
    // onOver = isOver;
  }

  if (!props.src) {
    const { fileName } = props,
      splitFileName = fileName.split('.'),
      filterType = splitFileName[splitFileName.length - 1];

    switch (filterType) {
      case 'doc':
        newSrc = '/icon/img_doc.png';
        break;
      case 'docx':
        newSrc = '/icon/img_docx.png';
        break;
      case 'csv':
        newSrc = '/icon/img_csv.png';
        break;
      case 'xls':
      case 'xlsx':
        newSrc = '/icon/img_xls.png';
        break;
      case 'ppt':
      case 'pptx':
        newSrc = '/icon/img_ppt.png';
        break;
      case 'pdf':
        newSrc = '/icon/img_pdf.png';
        break;
      case 'rar':
        newSrc = '/icon/img_rar.png';
        break;
      case 'zip':
        newSrc = '/icon/img_zip.png';
        break;

      default:
    }
  }

  const
    temp =
      <figure style={{ opacity: onDragging ? 0 : 1 }}>
        <span className='span-embed-scrollbar-cutter'>
          <img role='img' style={{ width: 145, height: 145 }} src={props.src || newSrc} alt='thumbnail' onError={event => { event.target.src = '/imgs/no_image_default.png'; event.target.onerror = null; }} />
        </span>

        <MaskLink href={props.href} />

        <RemoveIcon onFileDelete={e => {
          e.stopPropagation();
          props.ownerThis.onFileDelete(props.fileType, props.fileName);
        }} />
      </figure>;

  if (props.enableDnd) {
    const { connectDragSource, connectDropTarget } = props;
    return connectDragSource(connectDropTarget(temp));
  } else {
    return (temp);
  }
};

const PreviewVideo = props => {
  let onDragging = false;
  // let onOver;

  if (props.enableDnd) {
    const { isDragging/*, isOver*/ } = props;
    onDragging = isDragging;
    // onOver = isOver;
  }

  const
    temp =
      <figure style={{ opacity: onDragging ? 0 : 1 }}>
        <video controls preload='auto' controlsList='nodownload' onClick={(e) => { e.stopPropagation(); }}>
          <source src={props.href} type='video/mp4' />
          {'Your browser does not support the video tag.'}
        </video>

        <RemoveIcon onFileDelete={e => {
          e.stopPropagation();
          props.ownerThis.onFileDelete(props.fileType, props.fileName);
        }} />
      </figure>;

  if (props.enableDnd) {
    const { connectDragSource, connectDropTarget } = props;
    return connectDragSource(connectDropTarget(temp));
  } else {
    return (temp);
  }
};

PreviewImg.propTypes = {
  isDragging: PropTypes.bool.isRequired,
};
PreviewPDF.propTypes = {
  isDragging: PropTypes.bool.isRequired,
};
PreviewVideo.propTypes = {
  isDragging: PropTypes.bool.isRequired,
};

export const PreviewImgWithDnd = DragSource(ItemTypes.img, previewSource, collectSource)(DropTarget(ItemTypes.img, previewTarget, collectTarget)(PreviewImg));
export const PreviewPDFWithDnd = DragSource(ItemTypes.pdf, previewSource, collectSource)(DropTarget(ItemTypes.pdf, previewTarget, collectTarget)(PreviewPDF));
export const PreviewVideoWithDnd = DragSource(ItemTypes.video, previewSource, collectSource)(DropTarget(ItemTypes.video, previewTarget, collectTarget)(PreviewVideo));


// WEBPACK FOOTER //
// ./src/commonComponents/FilePreviewPs.jsx